import { ApolloError } from '@apollo/client';
import { handleErrorMessage } from '@medicusunion/front-utils';
import { message } from 'antd';

type ErrorResponseType = {
  body?: {
    message?: string;
  };
};

export const showErrorMessage = (err: ApolloError) =>
  handleErrorMessage(err, msg => {
    message.error(
      typeof msg === 'string' ? msg : msg?.message || 'Something went wrong'
    );
  });

export const getFirstErrorMessage = (err: ApolloError) => {
  const response = err?.graphQLErrors?.[0]?.extensions
    ?.response as ErrorResponseType;

  return response?.body?.message || 'Something went wrong';
};
